import { useFlag } from '@afterpaytouch/feature'
import { useCheckoutState, useCrossBorderTrade, useIsAfterpayAppGiftCardFlow } from '..'
import { Features } from '../../model/features'
import { GiftCardPromoBreakdown, parseGiftCardPromoBreakdown } from './parseGiftCardPromoBreakdown'

export type { GiftCardPromoBreakdown } from './parseGiftCardPromoBreakdown'

export const useGiftCardPromoBreakdown = (): GiftCardPromoBreakdown | null => {
  const { checkout, started } = useCheckoutState()
  const isGiftCardFlow = useIsAfterpayAppGiftCardFlow()
  const promotionUiEnabled = useFlag<boolean>(Features.CHECKOUT_GIFT_CARD_PROMOTION_UI_ENABLED, false)
  const { isCrossBorder } = useCrossBorderTrade()
  const displayedCurrency = started?.consumerAmount?.currency

  if (!isGiftCardFlow || promotionUiEnabled !== true || (isCrossBorder && displayedCurrency === undefined)) {
    return null
  }

  return parseGiftCardPromoBreakdown(checkout?.amount, checkout?.custom, displayedCurrency)
}
